import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PageShell from "../dashboard/PageShell";
import { Plus, Search, FileDown, ChevronDown } from "lucide-react";

interface ProjectItem {
  id: string;
  stt: number;
  projectName: string;
  status: string;
  startDate: string;
  endDate: string;
  taskLevel: string;
  taskType: string;
  chairperson: string;
  hostUnit: string;
  totalCost: string;
  fundingSource: string;
  allocatedCost: string;
  allocationYear: string;
  unallocatedCost: string;
  progress: string;
  year: string;
  function: string;
}

const mockData: ProjectItem[] = [
  {
    id: "1",
    stt: 1,
    projectName: "Nghiên cứu phần mềm quản lý KHCN có ứng dụng AI",
    status: "Đúng tiến độ",
    startDate: "12/2025",
    endDate: "12/2025",
    taskLevel: "Cấp Viện/ Chi nhánh Tỉnh/ TP: Hà Nội",
    taskType: "Đề tài",
    chairperson: "Thượng tá, VS. ThS Lê Anh Tuấn",
    hostUnit: "Trung tâm Đào tạo và Hợp tác Quốc tế",
    totalCost: "10.000",
    fundingSource: "Ngân sách sự nghiệp khoa học",
    allocatedCost: "8.000",
    allocationYear: "2025",
    unallocatedCost: "2.000",
    progress: "Đúng tiến độ",
    year: "2017",
    function: "- Chọn -",
  },
  {
    id: "2",
    stt: 2,
    projectName: "NC",
    status: "Đúng tiến độ",
    startDate: "10/2025",
    endDate: "06/2025",
    taskLevel: "Cấp Quốc gia",
    taskType: "Đề tài độc lập",
    chairperson: "Thượng tá, VS. ThS Lê Anh Tuấn",
    hostUnit: "Viện Khoa học Thủy lợi Miền Nam",
    totalCost: "25.000",
    fundingSource: "Ngân sách nhà nước",
    allocatedCost: "15.000",
    allocationYear: "2025",
    unallocatedCost: "10.000",
    progress: "Đúng tiến độ",
    year: "2016",
    function: "- Chọn -",
  },
  {
    id: "3",
    stt: 3,
    projectName:
      "Điều tra, nghiên cứu, đánh giá thực trạng và nguy cơ lũ lụt, sạt lờ đất lưu vực sông Sê Sanx và đề xuất các giải pháp phòng tránh và giải nhẹ",
    status: "Đúng tiến độ",
    startDate: "01/2022",
    endDate: "12/2022",
    taskLevel: "Cấp Bộ",
    taskType: "Đề tài nghiên cứu",
    chairperson: "Thượng tá, GS. TS Nguyễn Thị Hạnh",
    hostUnit: "Viện Khoa học Thủy lợi Miền Trung và Tây Nguyên",
    totalCost: "200",
    fundingSource: "Ngân sách sự nghiệp khoa học",
    allocatedCost: "150",
    allocationYear: "2022",
    unallocatedCost: "50",
    progress: "Đúng tiến độ",
    year: "1016",
    function: "- Chọn -",
  },
];

const IncomingDocuments: React.FC = () => {
  const navigate = useNavigate();
  const [selectedItems, setSelectedItems] = useState<number[]>([]);

  return (
    <PageShell title="Văn bản đến chưa xử lý">
      <div className="space-y-6">
        {/* Header Section */}
        <div className="flex justify-between items-center">
          <h1 className="text-xl font-semibold text-gray-800">
            Văn bản đến chưa xử lý
          </h1>
          <button
            onClick={() => navigate("/add-new-project")}
            className="bg-green-600 text-white px-3 py-2 rounded text-sm font-medium hover:bg-green-700 transition-colors flex items-center space-x-2"
          >
            <Plus className="h-4 w-4" />
            <span>Thêm mới Dự án</span>
          </button>
        </div>

        {/* Search and Filter Section */}
        <div className="bg-white rounded-lg p-4">
          <div className="space-y-4">
            {/* Row 1 - Search input + Search button */}
            <div className="flex items-center space-x-4">
              <div className="relative w-96">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
                <input
                  type="text"
                  placeholder="Tìm kiếm dự án"
                  className="w-full pl-10 pr-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
              <button className="bg-green-600 text-white px-3 py-2 rounded text-sm font-medium hover:bg-green-700 transition-colors">
                Tìm kiếm
              </button>
            </div>

            {/* Row 2 - Filter dropdowns */}
            <div className="flex items-center space-x-2">
              <select className="border border-gray-300 rounded-md px-2 py-2 text-sm bg-white w-36">
                <option>- Đơn vị chủ trì -</option>
              </select>
              <select className="border border-gray-300 rounded-md px-2 py-2 text-sm bg-white w-36">
                <option>- Chọn cấp -</option>
              </select>
              <select className="border border-gray-300 rounded-md px-2 py-2 text-sm bg-white w-36">
                <option>- Dạng đề tài -</option>
              </select>
              <select className="border border-gray-300 rounded-md px-2 py-2 text-sm bg-white w-36">
                <option>- Lĩnh vực -</option>
              </select>
              <select className="border border-gray-300 rounded-md px-2 py-2 text-sm bg-white w-36">
                <option>- Trạng thái -</option>
              </select>
              <select className="border border-gray-300 rounded-md px-2 py-2 text-sm bg-white w-36">
                <option>- Chủ nhiệm -</option>
              </select>
            </div>

            {/* Row 3 - More filter dropdowns */}
            <div className="flex items-center space-x-2">
              <select className="border border-gray-300 rounded-md px-2 py-2 text-sm bg-white w-36">
                <option>- Thư ký -</option>
              </select>
              <select className="border border-gray-300 rounded-md px-2 py-2 text-sm bg-white w-36">
                <option>- Lọc theo -</option>
              </select>
              <select className="border border-gray-300 rounded-md px-2 py-2 text-sm bg-white w-36">
                <option>- Từ năm -</option>
              </select>
              <select className="border border-gray-300 rounded-md px-2 py-2 text-sm bg-white w-36">
                <option>- Đến năm -</option>
              </select>
            </div>

            {/* Row 4 - Export button */}
            <div className="flex justify-start">
              <button className="bg-orange-500 text-white px-3 py-2 rounded text-sm font-medium hover:bg-orange-600 transition-colors flex items-center space-x-2">
                <FileDown className="h-4 w-4" />
                <span>Xuất ra file</span>
              </button>
            </div>
          </div>
        </div>

        {/* Data Table */}
        <div className="bg-white rounded-lg shadow overflow-hidden">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-2 py-3 text-left text-xs font-bold text-black uppercase tracking-wider border-r border-gray-200 w-8">
                    STT
                  </th>
                  <th className="px-2 py-3 text-left text-xs font-bold text-black uppercase tracking-wider border-r border-gray-200 w-48">
                    TÊN ĐỀ TÀI, NHIỆM VỤ
                  </th>
                  <th
                    className="px-2 py-3 text-center text-xs font-bold text-black uppercase tracking-wider border-r border-gray-200 w-32"
                    colSpan={2}
                  >
                    THỜI GIAN THỰC HIỆN
                  </th>
                  <th className="px-2 py-3 text-left text-xs font-bold text-black uppercase tracking-wider border-r border-gray-200 w-32">
                    CẤP NHIỆM VỤ
                  </th>
                  <th className="px-2 py-3 text-left text-xs font-bold text-black uppercase tracking-wider border-r border-gray-200 w-32">
                    CHỦ NHIỆM NHIỆM VỤ
                  </th>
                  <th className="px-2 py-3 text-left text-xs font-bold text-black uppercase tracking-wider border-r border-gray-200 w-40">
                    ĐƠN VỊ CHỦ TRÌ THỰC HIỆN
                  </th>
                  <th className="px-2 py-3 text-left text-xs font-bold text-black uppercase tracking-wider border-r border-gray-200 w-20">
                    TỔNG KINH PHÍ
                  </th>
                  <th className="px-2 py-3 text-left text-xs font-bold text-black uppercase tracking-wider border-r border-gray-200 w-32">
                    NGUỒN KINH PHÍ
                  </th>
                  <th
                    className="px-2 py-3 text-center text-xs font-bold text-black uppercase tracking-wider border-r border-gray-200 w-32"
                    colSpan={2}
                  >
                    KINH PHÍ ĐÃ CẤP
                  </th>
                  <th className="px-2 py-3 text-left text-xs font-bold text-black uppercase tracking-wider border-r border-gray-200 w-24">
                    KINH PHÍ CHƯA CẤP
                  </th>
                  <th className="px-2 py-3 text-left text-xs font-bold text-black uppercase tracking-wider border-r border-gray-200 w-20">
                    TIẾN ĐỘ
                  </th>
                  <th className="px-2 py-3 text-left text-xs font-bold text-black uppercase tracking-wider border-r border-gray-200 w-16">
                    #
                  </th>
                  <th className="px-2 py-3 text-left text-xs font-bold text-black uppercase tracking-wider w-20">
                    CHỨC NĂNG
                  </th>
                </tr>
                <tr>
                  <th className="px-2 py-3 text-left text-xs font-bold text-black uppercase tracking-wider border-r border-gray-200 w-8"></th>
                  <th className="px-2 py-3 text-left text-xs font-bold text-black uppercase tracking-wider border-r border-gray-200 w-48"></th>
                  <th className="px-2 py-3 text-center text-xs font-bold text-black uppercase tracking-wider border-r border-gray-200 w-16">
                    BẮT ĐẦU
                  </th>
                  <th className="px-2 py-3 text-center text-xs font-bold text-black uppercase tracking-wider border-r border-gray-200 w-16">
                    KẾT THÚC
                  </th>
                  <th className="px-2 py-3 text-left text-xs font-bold text-black uppercase tracking-wider border-r border-gray-200 w-32"></th>
                  <th className="px-2 py-3 text-left text-xs font-bold text-black uppercase tracking-wider border-r border-gray-200 w-32"></th>
                  <th className="px-2 py-3 text-left text-xs font-bold text-black uppercase tracking-wider border-r border-gray-200 w-40"></th>
                  <th className="px-2 py-3 text-left text-xs font-bold text-black uppercase tracking-wider border-r border-gray-200 w-20"></th>
                  <th className="px-2 py-3 text-left text-xs font-bold text-black uppercase tracking-wider border-r border-gray-200 w-32"></th>
                  <th className="px-2 py-3 text-center text-xs font-bold text-black uppercase tracking-wider border-r border-gray-200 w-16">
                    KINH PHÍ
                  </th>
                  <th className="px-2 py-3 text-center text-xs font-bold text-black uppercase tracking-wider border-r border-gray-200 w-16">
                    NĂM CẤP
                  </th>
                  <th className="px-2 py-3 text-left text-xs font-bold text-black uppercase tracking-wider border-r border-gray-200 w-24"></th>
                  <th className="px-2 py-3 text-left text-xs font-bold text-black uppercase tracking-wider border-r border-gray-200 w-20"></th>
                  <th className="px-2 py-3 text-left text-xs font-bold text-black uppercase tracking-wider border-r border-gray-200 w-16"></th>
                  <th className="px-2 py-3 text-left text-xs font-bold text-black uppercase tracking-wider w-20"></th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {mockData.map((item) => (
                  <tr key={item.id} className="hover:bg-gray-50">
                    <td className="px-2 py-4 whitespace-nowrap text-sm font-medium text-gray-900 border-r border-gray-200 w-8">
                      {item.stt}
                    </td>
                    <td className="px-2 py-4 text-sm text-gray-900 border-r border-gray-200 w-48">
                      <div className="space-y-1">
                        <div className="font-medium text-[#337ab7] text-[14px] leading-tight">
                          {item.projectName}
                        </div>
                        <div className="text-red-600 text-xs">
                          Trạng thái: {item.status}
                        </div>
                      </div>
                    </td>
                    <td className="px-2 py-4 text-sm text-gray-900 border-r border-gray-200 w-16">
                      {item.startDate}
                    </td>
                    <td className="px-2 py-4 text-sm text-gray-900 border-r border-gray-200 w-16">
                      {item.endDate}
                    </td>
                    <td className="px-2 py-4 text-sm text-gray-900 border-r border-gray-200 w-32">
                      <div className="space-y-1">
                        <div>{item.taskLevel}</div>
                        <div>Dạng: {item.taskType}</div>
                      </div>
                    </td>
                    <td className="px-2 py-4 text-sm text-gray-900 border-r border-gray-200 w-32">
                      {item.chairperson}
                    </td>
                    <td className="px-2 py-4 text-sm text-gray-900 border-r border-gray-200 w-40">
                      {item.hostUnit}
                    </td>
                    <td className="px-2 py-4 text-sm text-gray-900 border-r border-gray-200 w-20">
                      {item.totalCost}
                    </td>
                    <td className="px-2 py-4 text-sm text-gray-900 border-r border-gray-200 w-32">
                      {item.fundingSource}
                    </td>
                    <td className="px-2 py-4 text-sm text-gray-900 border-r border-gray-200 w-16">
                      {item.allocatedCost}
                    </td>
                    <td className="px-2 py-4 text-sm text-gray-900 border-r border-gray-200 w-16">
                      {item.allocationYear}
                    </td>
                    <td className="px-2 py-4 text-sm text-gray-900 border-r border-gray-200 w-24">
                      {item.unallocatedCost}
                    </td>
                    <td className="px-2 py-4 text-sm text-gray-900 border-r border-gray-200 w-20">
                      {item.progress}
                    </td>
                    <td className="px-2 py-4 text-sm text-gray-900 border-r border-gray-200 w-16">
                      {item.year}
                    </td>
                    <td className="px-2 py-4 whitespace-nowrap w-20">
                      <button className="bg-[#337ab7] text-white px-1 py-1 rounded text-xs font-medium hover:bg-[#2e6da4] transition-colors flex items-center space-x-1">
                        <span>{item.function}</span>
                        <ChevronDown className="h-3 w-3" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Pagination inside the table container */}
          <div className="flex justify-between items-center p-4 border-t border-gray-200">
            <div className="text-sm font-medium text-gray-700">
              Hiển thị <span className="font-bold">1</span> đến{" "}
              <select className="font-bold text-blue-600 border-none bg-transparent focus:ring-0 focus:outline-none text-sm">
                <option>10</option>
                <option>20</option>
                <option>50</option>
                <option>100</option>
              </select>{" "}
              trong <span className="font-bold">10000</span> kết quả
            </div>
            <div className="flex space-x-2">
              <button className="px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-md hover:bg-gray-50">
                &lt;
              </button>
              <button className="px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-md hover:bg-gray-50">
                1
              </button>
              <button className="px-3 py-2 text-sm font-medium text-white bg-[#337ab7] border border-[#337ab7] rounded-md">
                2
              </button>
              <button className="px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-md hover:bg-gray-50">
                3
              </button>
              <button className="px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-md hover:bg-gray-50">
                &gt;
              </button>
            </div>
          </div>
        </div>
      </div>
    </PageShell>
  );
};

export default IncomingDocuments;
